import { CdkDialogContainer, DialogModule } from '@angular/cdk/dialog';
import { Component, computed, inject } from '@angular/core';
import { DarkModeService } from 'src/shared/services/darkmode/darkmode_service';
import { DialogWrapperComponent } from './dialog-wrapper.component';

@Component({
  selector: 'app-cdk-dialog-container-unpadded',
  imports: [DialogModule, DialogWrapperComponent],
  template: '<app-dialog-wrapper><ng-template cdkPortalOutlet></ng-template></app-dialog-wrapper>',
  host: {
    '[attr.data-theme]': 'theme()',
  },
  styles: [
    `
      :host {
        display: block;
        background: var(--Vetai-Backgrounds--Base);
        border-radius: 0.5rem;
        overflow-y: auto;
        max-height: calc(100vh - 2rem);
        width: 100%;
      }
      .no-padding {
        padding: 0;
      }
    `,
  ],
})
export class CdkDialogContainerThemedComponent extends CdkDialogContainer {
  darkModeService = inject(DarkModeService);
  theme = computed(() => (this.darkModeService.darkModeOn() ? 'dark' : 'light'));
}
